export { default } from './FullScreenPage';
